import Api from '../http.service';

/**
add authentication message 
 */
export const addAuthSms = () =>
  Api.GET({ url: `expired_activity/add_auth_sms` });

/**
 * check verification Authentication sms
 * @param {Object} payload
 * @param {String} payload.verifyCode
 */
export const checkVerifyAuthSms = (payload) =>
  Api.GET({ url: `expired_activity/verify_auth_sms/${payload.verifyCode}` });

/**
 * forget password
 * @param {String} payload
 */
export const forgetPassword = (email) =>
  Api.GET({ url: `expired_activity/add_auth_pass/${email}` });
